import React, { ReactElement, useState } from "react";
import { useAppDispatch } from "redux/hooks";
import { Translate } from "react-redux-i18n";
import { Box, TextField, Button, InputAdornment, Typography } from "@mui/material";
import FontAwesomeIcon from "components/shared/FontAwesomeIcon";
import { loginRequested, CurrentUser } from "redux/auth/authSlice";
import { closeDialog } from "redux/dialog/dialogSlice";
import styles from "./styles.module.scss";
interface IProps {
  handleRightDrawer?: () => void;
  skinLogo?: string
}
export default function LoginForm({ handleRightDrawer, skinLogo }: IProps): ReactElement {
  const dispatch = useAppDispatch();
  const [userCredentials, setCredentials] = useState<CurrentUser>({
    username: "",
    password: "",
  });
  const [triggerPassword, setTriggerPassword] = useState<boolean>(false)

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    dispatch(loginRequested(userCredentials));
    handleRightDrawer && handleRightDrawer();
    dispatch(closeDialog())
  };
  const handleChange = (event: React.FormEvent) => {
    const { value, name } = event.target as HTMLInputElement;
    setCredentials({ ...userCredentials, [name]: value });
  };
  return (
    <form onSubmit={handleSubmit}>
      <Box className={styles.logContainerDialog}>
        <img src={skinLogo} className={styles.skinLogo} />
        <Box className={styles.loginDialog}>
          <TextField
            id="username"
            name="username"
            placeholder="Username"
            required
            onChange={handleChange}
            className={styles.loginInput}
          />
        </Box>
        <Box className={styles.loginDialog}>
          <TextField
            name="password"
            id="password"
            placeholder="Password"
            type={triggerPassword ? "text" : "password"}
            required
            onChange={handleChange}
            InputProps={{
              endAdornment:
                <InputAdornment
                  position="end"
                  onClick={() => setTriggerPassword(!triggerPassword)}
                  className={styles.showPassword}
                >
                  <FontAwesomeIcon name="eye" type="fas" color="white" />
                </InputAdornment>
            }}
            className={styles.loginInput}
          />
        </Box>

        <Box className={styles.loginIconDialog}>
          <Button
            type="submit"
            variant="contained"
            color="secondary"
          >
            <Typography className={styles.loginButtonLabel}>
              <Translate value="buttons.login" />
            </Typography>
          </Button>
        </Box>
      </Box>
    </form >
  );
}
